const amount = (value) => {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (typeof value === 'string' && !value.trim()) return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
};

// A blank overhead or margin means none, as on main and as the row labels show ("0% overhead").
const isBlank = (value) => value === undefined || value === null || (typeof value === 'string' && !value.trim());
const percent = (value) => (isBlank(value) ? 0 : amount(value));

export function calculateConsultingRate(input) {
  const income = amount(input.income);
  const hoursPerWeek = amount(input.hoursPerWeek);
  const weeks = amount(input.weeks);
  const overhead = percent(input.overhead);
  const margin = percent(input.margin);
  if ([income, hoursPerWeek, weeks, overhead, margin].includes(null)
    || hoursPerWeek <= 0 || hoursPerWeek > 80 || weeks <= 0 || weeks > 52
    || overhead > 100 || margin > 90) return null;

  const loadedIncome = income * (1 + overhead / 100);
  const revenueTarget = loadedIncome / (1 - margin / 100);
  const billableHours = hoursPerWeek * weeks;
  const hourlyRate = revenueTarget / billableHours;
  const result = { loadedIncome, revenueTarget, billableHours, hourlyRate, dayRate: hourlyRate * 8, projectFee: hourlyRate * 10 };
  return Object.values(result).every(Number.isFinite) ? result : null;
}
